import React, { useEffect } from 'react'

import { useStore } from 'reto'
import { useNavigate,useLocation } from 'react-router-dom'

import AppStorages from '../Storages/AppStorage'


/**
 * 
 * 启动页  - Load
 * 
 * 
 */

const Load = () => {

  const navigate = useNavigate()
  const { OnReady } = useStore(AppStorages)

  const location = useLocation()
  // 获取全景图片的地址，并传递过去
  const imgId = location.search.split('?imgId=')[1]


  useEffect(() => {
    OnReady && initialize()
  }, [OnReady])

  const initialize = () => {
    console.log('传递的ImgId',location,imgId);
    // setTimeout(() => {
    //   navigate(`/share?imgId=${imgId}`)
    // }, 500)
  }

  return <>
        参数错误
  </>
}

export default Load